import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import './AcceptQuote.css';
import { acceptQuote, setIsOnQuoteScreen } from '../../../actions/salesActions';
import { refreshUpdatedCartItem } from '../../../actions/cartActions';

class AcceptQuote extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isTop: true,
            isBottom: true
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.isBottom = this.isBottom.bind(this);
        this.handleAcceptQuote = this.handleAcceptQuote.bind(this);
    } 

    isBottom(el: any) {
        return el().bottom <= window.innerHeight;
    }

    componentDidMount() {
        document.addEventListener('scroll', (event: any) => {
            const limit = (document.body.offsetHeight - window.innerHeight) - 50;
            const isTop = window.scrollY < 200;
            const isBottom = !isMobile ? (window.scrollY > limit) : false;

            if (isTop !== this.state.isTop) {
                this.setState({ isTop });
            }

            if (isBottom !== this.state.isBottom) {
                this.setState({ isBottom });
            }
        });
    }
    async handleAcceptQuote(e: any) {
        this.props.dispatchSetIsOnQuoteScreen(false, "", "");
        if (this.props.sales.isNewItem) {
            this.props.dispatchAcceptQuote()
        }
        else {
            this.props.dispatchUpdateItemOnQuote()
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    public render() {
        return (
            <>
                <div id="AcceptQuote-sidebar" className={this.state.isTop || this.state.isBottom ? 'invisible' : 'visible'} onClick={this.handleAcceptQuote}>
                    <div id="Side-container">
                        <div className="row">
                            <div className="col-12 col-lg-9 pr-lg-0 padding">
                                <p>{this.props.sales.isNewItem ? "Add to quote" : "Update quote"}</p>
                                <strong>{this.props.profile.currencySymbol} {this.props.premuim} pm</strong>
                            </div>

                            <div className="col-lg-3 d-none d-lg-block">
                                <img src="./images/AcceptQuote/arrow-add-quote-nugreen-44px-88px.svg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(push(des)),
        dispatchAcceptQuote: () => dispatch(acceptQuote(false)),
        dispatchUpdateItemOnQuote: () => dispatch(refreshUpdatedCartItem()),
        dispatchSetIsOnQuoteScreen: (flag, itemId, itemDescription) => dispatch(setIsOnQuoteScreen(flag, itemId, itemDescription)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AcceptQuote);